import * as React from 'react';
import { observer } from 'mobx-react';

import { ChannelKind, OpenedChannelKind } from 'shared/entities/channels';
import { useChannelsModalStore } from 'stores/ChannelsModalStore';
import { AnyChannelCreationStores } from 'stores/channelCreationStores';

import Jivo from './Jivo';
import Max from './Max';
import Telegram from './Telegram';
import Viber from './Viber';
import VK from './VK';
import Wazzup from './Wazzup';
import Widget from './Widget';
import WhatsApp from './WhatsApp';
import FormLoader from './FormLoader';

import './Form.modules.scss';

const mapChannelKindToComponent: Record<
  OpenedChannelKind | ChannelKind.WHATSAPP,
  React.FC<{ channelCreationStore: AnyChannelCreationStores }>
> = {
  [ChannelKind.TELEGRAM]: Telegram,
  [ChannelKind.VK]: VK,
  [ChannelKind.VB]: Viber,
  [ChannelKind.JIVO]: Jivo,
  [ChannelKind.WHATSAPP]: WhatsApp,
  [ChannelKind.WZ]: Wazzup,
  [ChannelKind.MAX]: Max,
  [ChannelKind.WIDGET]: Widget
};

type Props = {
  channelKind: OpenedChannelKind | ChannelKind.WHATSAPP;
};

const Form: React.FC<Props> = ({ channelKind }) => {
  const { store } = useChannelsModalStore();

  const Component = mapChannelKindToComponent[channelKind];

  if (
    !store.channelCreationStore ||
    store.channelCreationStore?.kind !== channelKind
  ) {
    return <FormLoader />;
  }

  return (
    <div styleName="form">
      <Component channelCreationStore={store.channelCreationStore} />
    </div>
  );
};

export default observer(Form);
